(() => {
  if (window.wwCampaignPdpLoaded) return;
  window.wwCampaignPdpLoaded = true;
  const init = () => document.querySelectorAll('[data-ww-pdp]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    document.body.classList.add('ww-pdp-enabled');
    const section = document.getElementById(`shopify-section-${root.dataset.sectionId}`);
    if (!section) return;
    const labels = JSON.parse(root.querySelector('[data-ww-pdp-labels]').textContent);
    const updateSeason = () => {
      if (root.dataset.campaign === "bfcm") return;
      const now = Date.now();
      const periods = [
        {start:Date.parse('2026-10-19T00:00:00-07:00'),end:Date.parse('2026-11-01T00:00:00-07:00'),preview:Date.parse('2026-10-12T00:00:00-07:00'),key:'halloween'},
        {start:Date.parse('2026-11-16T00:00:00-08:00'),end:Date.parse('2026-12-01T00:00:00-08:00'),preview:Date.parse('2026-11-09T00:00:00-08:00'),key:'bfcm'}
      ];
      const period = periods.find(p => now >= p.preview && now < p.end);
      const band = root.querySelector('[data-ww-season]');
      band.hidden = !period;
      if (!period) return;
      band.dataset.season = period.key;
      band.querySelector('[data-ww-season-title]').textContent = labels[period.key + (now < period.start ? 'Soon' : '')];
    };
    const updateWarehouse = () => {
      const checked = [...section.querySelectorAll('variant-selects fieldset input:checked')];
      const warehouse = checked.find(input => /warehouse/i.test(input.closest('fieldset')?.dataset.optionName || ''));
      const selected = warehouse?.value || '';
      const mismatch = (root.dataset.country === 'CA' && /US Warehouse/i.test(selected)) || (root.dataset.country === 'US' && /(?:CA|Canada) Warehouse/i.test(selected));
      root.querySelector('[data-ww-warehouse-warning]').hidden = !mismatch;
      return mismatch;
    };
    updateSeason();
    const initialWarehouseMismatch = updateWarehouse();
    // Start with the active market warehouse, including after the original currency widget
    // redirects with a variant from the previous market. Matching deep links and later manual choices stay intact.
    if (!new URL(window.location.href).searchParams.has('variant') || initialWarehouseMismatch) {
      customElements.whenDefined('variant-selects').then(() => {
        const picker = document.getElementById(`variant-selects-${root.dataset.sectionId}`);
        const fields = [...(picker?.querySelectorAll('fieldset') || [])];
        const warehouse = fields.find(field => /warehouse/i.test(field.dataset.optionName || ''));
        const desired = root.dataset.country === 'CA' ? /^(?:CA|Canada) Warehouse$/i : root.dataset.country === 'US' ? /^US Warehouse$/i : null;
        const data = JSON.parse(root.querySelector('[data-ww-pdp-variants]').textContent);
        const warehouseIndex = data.optionNames.findIndex(name => /warehouse/i.test(name));
        const selected = data.optionNames.map(name => fields.find(field => field.dataset.optionName === name)?.querySelector('input:checked')?.value);
        const candidates = data.variants.filter(variant => variant.available && desired?.test(variant.options[warehouseIndex] || ''));
        const score = variant => variant.options.reduce((total, value, index) => total + (index !== warehouseIndex && value === selected[index] ? 1 : 0), 0);
        candidates.sort((a,b) => score(b) - score(a));
        const target = candidates[0];
        let changed;
        if (target) {
          data.optionNames.forEach((name,index) => {
            const field = fields.find(item => item.dataset.optionName === name);
            const input = [...(field?.querySelectorAll('input[type="radio"]') || [])].find(item => item.value === target.options[index]);
            if (input && !input.checked) {input.checked = true;changed = input;}
          });
          if (changed) changed.dispatchEvent(new Event('change',{bubbles:true}));
        } else {
          const option = [...(warehouse?.querySelectorAll('input[type="radio"]') || [])].find(input => desired?.test(input.value));
          if (option && !option.checked && !option.disabled) option.click();
        }
      });
    }
    section.addEventListener('change', updateWarehouse);
    // Use the theme's resolved variant event so guidance follows actual native selections.
    document.addEventListener('product:variant-change', e => {
      if (String(e.detail?.sectionId) === root.dataset.sectionId) updateWarehouse();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
